module.exports = __webpack_public_path__ + "images/emoji/thought_balloon.40aa1ba3c1ddf2882aac.png";